import React from "react";
import { Mono } from "assets/media/svgs";
import cx from "classnames";
import { Button, ButtonVariant } from "brass-ui-kit";
import { StaticImage } from "gatsby-plugin-image";

import * as styles from "./BusinessSupport.module.scss";
import OpenAccountButton from "components/design-system/OpenAccountButton/OpenAccountButton";

const BusinessSupport = () => {
  return (
    <section className={styles.BusinessSupport}>
      <div className={styles.BusinessSupport_container}>
        <div className={styles.BusinessSupport_image}>
          <StaticImage
            src="../../../assets/media/images/customer-abdul.png"
            alt="Abdul Hassan, CEO Mono"
            as="span"
          />
          <div className={styles.BusinessSupport_image_meta}>
            <div>
              <h3 className={styles.BusinessSupport_image_meta_text}>
                Abdul Hassan
              </h3>
              <p className={styles.BusinessSupport_image_meta_text}>
                Co-Founder and CEO, mono
              </p>
            </div>
            <Mono />
          </div>
        </div>
        <header className={styles.BusinessSupport_header}>
          <h2
            className={cx(
              styles.BusinessSupport_header_title,
              styles.BusinessSupport_header_text
            )}
          >
            For entrepreneurs, startups, and medium scale businesses
          </h2>
          <p className={styles.BusinessSupport_header_text}>
            We support small and medium businesses with tools, and integrations
            to run their business smarter and more effectively. Join thousands
            of business owners who trust Brass with their business finance.
          </p>
          <OpenAccountButton />
        </header>
      </div>
    </section>
  );
};

export default BusinessSupport;
